import { axiosInstance } from "..";

const sendChatMessage = async (projectID, data) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .post(`/internal/chat/${projectID}`, data)
      .then((res) => {
        if (res.status === 200) {
          return resolve(res);
        }
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export default sendChatMessage;
